export const FETCH_RESULT_LIST = 'FETCH_RESULT_LIST'
export const FETCH_RESULT_MAP = 'FETCH_RESULT_MAP'
export const FETCH_RESULT_PERIOD = 'FETCH_RESULT_PERIOD'
export const FETCH_RESULT_FILTERED = 'FETCH_RESULT_FILTERED'
export const FETCH_CATALOG = 'FETCH_CATALOG'
export const ERROR_API = 'ERROR_API'

export const UPDATE_RESULT_LIST = 'UPDATE_RESULT_LIST'
export const UPDATE_RESULT_MAP = 'UPDATE_RESULT_MAP'
export const UPDATE_RESULT_PERIOD = 'UPDATE_RESULT_PERIOD'
export const UPDATE_RESULT_FILTERED = 'UPDATE_RESULT_FILTERED'
export const UPDATE_CATALOG = 'UPDATE_CATALOG'

export const SEARCH_EXHIBITION_LIST = 'SEARCH_EXHIBITION_LIST'
export const SEARCH_EXHIBITION_SECTION_LIST = 'SEARCH_EXHIBITION_SECTION_LIST'
export const SEARCH_EXHIBITOR_LIST = 'SEARCH_EXHIBITOR_LIST'
export const SEARCH_EXHIBITED_WORK_LIST = 'SEARCH_EXHIBITED_WORK_LIST'

export const SEARCH_EXHIBITION_MAP = 'SEARCH_EXHIBITION_MAP'
export const SEARCH_EXHIBITOR_MAP = 'SEARCH_EXHIBITOR_MAP'
export const SEARCH_EXHIBITED_WORK_MAP = 'SEARCH_EXHIBITED_WORK_MAP'

export const SEARCH_EXHIBITION_PERIOD = 'SEARCH_EXHIBITION_PERIOD'
export const SEARCH_EXHIBITOR_PERIOD = 'SEARCH_EXHIBITOR_PERIOD'
export const SEARCH_EXHIBITED_WORK_PERIOD = 'SEARCH_EXHIBITED_WORK_PERIOD'

export const GET_EXHIBITED_WORK_FILTERED_BY_COLUMN = 'GET_EXHIBITED_WORK_FILTERED_BY_COLUMN'
export const GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN = 'GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN'

export const GET_CATALOG = 'GET_CATALOG'

export const SET_FILTER = 'SET_FILTER'

export const ITEMS_PER_PAGE_FOR_MAP_DISPLAY = 3000

export const GET_EXHIBITION_ADDRESS = 'GET_EXHIBITION_ADDRESS'
export const ADD_RESULT_MAP = 'ADD_RESULT_MAP'

// const transformResponseToObject = (response) => {
//   console.log(response)
//   return response.records.map((currentRecord) => {
//     const objectSkeleton = {}
//     response.columns.forEach((currentColumn, indexColumn) => {
//       Object.assign(objectSkeleton, {[currentColumn]: currentRecord[indexColumn]})
//     })
//     return objectSkeleton
//   })
// }




// WEBPACK FOOTER //
// ./src/store/search/constants.js